import i18n from './../../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../../core/components/input-widget/BaseModel";
import cloneDeep from "lodash/cloneDeep";
import helperService from "@/core/services/helper.service";

export default class CategoryModel extends BaseModel {
  name = {};
  premiums = [];
  minimum_premium = null;
  minimum_commission = null;
  lot_start_number = 0;
  lot_end_number = 0;
  commissions = [];
  lot_handling_charge = null;
  insurance_rate = null;
  withdrawal_fee = null;

  static TRANSLATABLE_FIELDS = ['name'];

  rules = {
    name: 'required',
    minimum_premium: 'required',
    minimum_commission: 'required',
  };

  attributeLabels = {
    uuid: i18n.t('UUID'),
    name: i18n.t('Name'),
    lot_handling_charge: i18n.t('Entry Fee'),
    tax_rate: i18n.t('Tax Rate'),
    minimum_premium: i18n.t('Minimum Premium'),
    minimum_commission: i18n.t('Commission Premium'),
    lot_start_number: i18n.t('Lot Start Number'),
    lot_end_number: i18n.t('Lot End Number'),
    insurance_rate: i18n.t('L/D Warranty'),
    withdrawal_fee: i18n.t('Withdrawal Fee'),
  };

  constructor(data = {}) {
    super();
    data = helperService.reverseCalculateTiers(data)
    Object.assign(this, {...data});
    this.initTranslatableFields(this);
  }

  toJSON() {
    let data = cloneDeep(super.toJSON());
    data = helperService.calculateTiers(data)
    return data
  }
}

defineTranslatableProperties(CategoryModel);


